module.exports = __webpack_public_path__ + "img/ico-introduction-1.686fbfe7.svg";